import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { fetchResourceFlow } from '../../api/dashboard';
interface Props {
    activeRegion: string;
}
const AppFlowPanel: React.FC<Props> = ({ activeRegion }) => {
    const [viewIndex, setViewIndex] = useState(0);
    const views = ['Global', 'Chengde', 'Panzhihua', 'International'];
    const [sankeyData, setSankeyData] = useState<{ nodes: any[], links: any[] }>({ nodes: [], links: [] });
    useEffect(() => {
        const loadData = async () => {
            try {
                const data = await fetchResourceFlow();
                setSankeyData(data || { nodes: [], links: [] });
            } catch (error) {
                console.error("Failed to fetch resource flow:", error);
            }
        };
        loadData();
    }, []);
    const getFilteredData = () => {
        if (!sankeyData?.links?.length) return { nodes: [], links: [] };
        const regionMap: { [key: string]: string } = {
            'Chengde': '承德',
            'Panzhihua': '攀枝花',
            'Shanghai': '上海',
            'Hunan': '湖南'
        };
        const targetSource = regionMap[activeRegion];
        const fixedSources = ['承德', '中国', '南非', '俄罗斯', '美国'];
        const filteredLinks = sankeyData.links.filter((l: any) =>
            fixedSources.includes(l.source) || (targetSource && l.source === targetSource)
        );
        const nodeNames = new Set();
        filteredLinks.forEach((l: any) => {
            nodeNames.add(l.source);
            nodeNames.add(l.target);
        });
        const filteredNodes = sankeyData.nodes.filter((n: any) => nodeNames.has(n.name));
        return { nodes: filteredNodes, links: filteredLinks };
    };
    const { nodes: displayNodes, links: displayLinks } = getFilteredData();
    const option = {
        backgroundColor: 'transparent',
        tooltip: { trigger: 'item', triggerOn: 'mousemove' },
        series: [
            {
                type: 'sankey',
                layout: 'none',
                right: '5%',
                left: '5%',
                emphasis: { focus: 'adjacency' },
                lineStyle: { color: 'gradient', curveness: 0.5 },
                label: { color: '#fff', fontSize: 12 },
                data: displayNodes,
                links: displayLinks
            }
        ]
    };
    return (
        <div className="hud-panel bottom-panel">
            <h3>资源流向 ({activeRegion === 'Chengde' ? '承德' : activeRegion === 'Panzhihua' ? '攀枝花' : activeRegion === 'Shanghai' ? '上海' : activeRegion === 'Hunan' ? '湖南' : '全球视图'})</h3>
            <ReactECharts option={option} style={{ height: '100%', width: '100%' }} />
        </div>
    );
};
export default AppFlowPanel;
